import React, { useEffect, useRef, useState } from "react";

// Video yalnızca görünür alana yaklaşınca yüklenir; sayfa açılışında megabaytlarca indirme yapılmaz.
const VideoPlayer = ({ source, className = "myvideo" }) => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = containerRef.current;
    if (!node || !("IntersectionObserver" in window)) {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={className} ref={containerRef}>
      {visible && <video src={source} autoPlay loop muted playsInline />}
    </div>
  );
};

export default VideoPlayer;
